'use strict';

/**
 * Dependencies
 */
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'bootstrap';

import { initGsap } from './gsap.js';

import domReady from './domReady.js';

import nodePodcastListing from './templates/content/node--podcast-listing';
import pubListing from './templates/content/node--publication-listing';

domReady(async () => {
  await initGsap();

  if (document.querySelector('.js-animate-scroll')) {
    const animations = await import('./global/animations');
    animations.default.init();
  }

  if (document.querySelector('#site-header-m')) {
    const mobileNavigation = await import('./global/mobile-navigation');
    mobileNavigation.default.init();
  }

  if (document.querySelector('.btn-reduced-motion')) {
    const reducedMotion = await import('./global/reduced-motion');
    reducedMotion.default.init();
  }

  if (document.querySelector('.site-search')) {
    const search = await import('./global/search');
    search.default.init();
  }

  if (document.querySelector('.animate-title')) {
    const titles = await import('./global/titles');
    titles.default.init();
  }

  if (document.querySelector('.donate-cta')) {
    const donateCta = await import('./global/donate-cta');
    donateCta.default.init();
  }

  if (document.querySelector('.block--page-header-banner-block')) {
    const pageHeaderBannerBlock = await import('./templates/block/block--page-header-banner-block');
    pageHeaderBannerBlock.default.init();
  }

  if (document.querySelector('.block--system-menu-blockmain')) {
    const systemMenuBlockmain = await import('./templates/block/block--system-menu-blockmain');
    systemMenuBlockmain.default.init();
  }

  if (document.querySelector('.paragraph--type--accordion')) {
    const accordion = await import('./templates/paragraph/paragraph--type--accordion');
    accordion.default.init();
  }

  if (document.querySelector('.paragraph--type--faq-accordion')) {
    const faqAccordion = await import('./templates/paragraph/paragraph--type--faq-accordion');
    faqAccordion.default.init();
  }

  if (document.querySelector('.paragraph--type--full-width-carousel')) {
    const fullWidthCarousel = await import('./templates/paragraph/paragraph--type--full-width-carousel');
    fullWidthCarousel.default.init();
  }

  if (document.querySelector('.full-width-cta__video-wrap')) {
    const fullWidthCta = await import('./templates/paragraph/paragraph--type--full-width-cta');
    fullWidthCta.default.init();
  }

  if (document.querySelector('.paragraph--type--full-width-video')) {
    const fullWidthVideo = await import('./templates/paragraph/paragraph--type--full-width-video');
    fullWidthVideo.default.init();
  }

  if (document.querySelector('.paragraph--type--illustration-carousel-cta')) {
    const illustrationCarouselCta = await import('./templates/paragraph/paragraph--type--illustration-carousel-cta');
    illustrationCarouselCta.default.init();
  }

  if (document.querySelector('.paragraph--type--image-carousel-cta')) {
    const imageCarouselCta = await import('./templates/paragraph/paragraph--type--image-carousel-cta');
    imageCarouselCta.default.init();
  }

  if (document.querySelector('.paragraph--type--staff-profiles')) {
    const staffProfiles = await import('./templates/paragraph/paragraph--type--staff-profiles');
    staffProfiles.default.init();
  }

  if (document.querySelector('.paragraph--type--interactive-image-embed')) {
    const interactiveImageEmbed = await import('./templates/paragraph/paragraph--type--interactive-image-embed');
    interactiveImageEmbed.default.init();
  }

  if (document.querySelector('.paragraph--type--podcasts')) {
    const podcasts = await import('./templates/paragraph/paragraph--type--podcasts');
    podcasts.default.init();
  }

  if (document.querySelector('.paragraph--type--quiz-item-embed')) {
    const quizEmbed = await import('./templates/paragraph/paragraph--type--quiz-embed');
    quizEmbed.default.init();
  }

  if (document.querySelector('.paragraph--type--quick-links-slider')) {
    const quickLinksSlider = await import('./templates/paragraph/paragraph--type--quick-links-slider');
    quickLinksSlider.default.init();
  }

  if (document.querySelector('.paragraph--type--scroll-banner-cta')) {
    const scrollBannerCta = await import('./templates/paragraph/paragraph--type--scroll-banner-cta');
    scrollBannerCta.default.init();
  }

  if (document.querySelector('.paragraph--type--stats')) {
    const stats = await import('./templates/paragraph/paragraph--type--stats');
    stats.default.init();
  }

  if (document.querySelector('.paragraph--type--testimonial')) {
    const testimonial = await import('./templates/paragraph/paragraph--type--testimonial');
    testimonial.default.init();
  }

  if (document.querySelector('.paragraph--type--text-and-icon')) {
    const textAndIcon = await import('./templates/paragraph/paragraph--type--text-and-icon');
    textAndIcon.default.init();
  }

  if (document.querySelector('.paragraph--type--timeline-embed')) {
    const timelineEmbed = await import('./templates/paragraph/paragraph--type--timeline-embed');
    timelineEmbed.default.init();
  }

  if (document.querySelector('.paragraph--type--video-grid')) {
    const videoGrid = await import('./templates/paragraph/paragraph--type--video-grid');
    videoGrid.default.init();
  }

  if (document.querySelector('.paragraph--type--pim-map')) {
    const PIMMap = await import('./templates/paragraph/paragraph--type--pim-map');
    PIMMap.default.init();
  }

  nodePodcastListing.init();
  pubListing.init();

  AOS.init({
    easing:   'ease-out-cubic',
    duration: 600,
    once:     true,
  });
});
